"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "Modal", {
    enumerable: true,
    get: function() {
        return Modal;
    }
});
var _themetools = require("@chakra-ui/theme-tools");
var commonStyle = {
    padding: "1.25rem",
    paddingInlineStart: 0,
    paddingInlineEnd: 0,
    backgroundColor: "background-card",
    borderRadius: "0.5rem"
};
var Modal = {
    baseStyle: {
        overlay: {
            backgroundColor: (0, _themetools.transparentize)("background-overlay", 0.75)
        },
        dialog: {
            boxShadow: "elevation-modals",
            backgroundColor: "background-card"
        },
        header: commonStyle,
        body: commonStyle,
        footer: commonStyle
    },
    sizes: {
        auto: {
            dialog: {
                maxW: "none",
                width: "auto"
            }
        }
    },
    defaultProps: {
        size: "auto"
    }
};
